import {
  FETCH_WEEKLY_UPDATES,
  FETCH_WEEKLY_UPDATES_START,
  FETCH_WEEKLY_UPDATES_SUCCESS,
  FETCH_WEEKLY_UPDATES_ERROR,
  FETCH_REMAINING_WEEKLY_UPDATES,
  FETCH_REMAINING_WEEKLY_UPDATES_START,
  FETCH_REMAINING_WEEKLY_UPDATES_SUCCESS,
  FETCH_REMAINING_WEEKLY_UPDATES_ERROR,
  POST_WEEKLY_UPDATE,
  POST_WEEKLY_UPDATE_START,
  POST_WEEKLY_UPDATE_SUCCESS,
  POST_WEEKLY_UPDATE_ERROR,
  DELETE_WEEKLY_UPDATE,
  DELETE_WEEKLY_UPDATE_START,
  DELETE_WEEKLY_UPDATE_SUCCESS,
  DELETE_WEEKLY_UPDATE_ERROR,
  RESET_NEW_WEEKLY_UPDATE,
  UPDATE_WEEK_NUMBER,
  UPDATE_YEAR,
  UPDATE_ROLE,
  UPDATE_TEXT,
  UPDATE_TOTAL_COUNT,
  RESET_TOTAL_COUNT,
  INCREMENT_TOTAL_COUNT,
  DECREMENT_TOTAL_COUNT
} from './constants'

const fetchWeeklyUpdates = (projectId, offset, limit) => ({ type: FETCH_WEEKLY_UPDATES, projectId, offset, limit })
const fetchWeeklyUpdatesStart = () => ({ type: FETCH_WEEKLY_UPDATES_START })
const fetchWeeklyUpdatesSuccess = () => ({ type: FETCH_WEEKLY_UPDATES_SUCCESS })
const fetchWeeklyUpdatesError = (error) => ({ type: FETCH_WEEKLY_UPDATES_ERROR, error })

const fetchRemainingWeeklyUpdates = (projectId, offset, limit) => ({ type: FETCH_REMAINING_WEEKLY_UPDATES, projectId, offset, limit })
const fetchRemainingWeeklyUpdatesStart = () => ({ type: FETCH_REMAINING_WEEKLY_UPDATES_START })
const fetchRemainingWeeklyUpdatesSuccess = () => ({ type: FETCH_REMAINING_WEEKLY_UPDATES_SUCCESS })
const fetchRemainingWeeklyUpdatesError = (error) => ({ type: FETCH_REMAINING_WEEKLY_UPDATES_ERROR, error })

const postWeeklyUpdate = (params) => ({ type: POST_WEEKLY_UPDATE, params })
const postWeeklyUpdateStart = () => ({ type: POST_WEEKLY_UPDATE_START })
const postWeeklyUpdateSuccess = () => ({ type: POST_WEEKLY_UPDATE_SUCCESS })
const postWeeklyUpdateError = (error) => ({ type: POST_WEEKLY_UPDATE_ERROR, error })

const deleteWeeklyUpdate = (id) => ({ type: DELETE_WEEKLY_UPDATE, id })
const deleteWeeklyUpdateStart = () => ({ type: DELETE_WEEKLY_UPDATE_START })
const deleteWeeklyUpdateSuccess = () => ({ type: DELETE_WEEKLY_UPDATE_SUCCESS })
const deleteWeeklyUpdateError = (error) => ({ type: DELETE_WEEKLY_UPDATE_ERROR, error })

const resetNewWeeklyUpdate = () => ({ type: RESET_NEW_WEEKLY_UPDATE })

const updateWeekNumber = (weekNumber) => ({ type: UPDATE_WEEK_NUMBER, weekNumber })
const updateYear = (year) => ({ type: UPDATE_YEAR, year })
const updateRole = (role) => ({ type: UPDATE_ROLE, role })
const updateText = (text) => ({ type: UPDATE_TEXT, text })

const updateTotalCount = (count) => ({ type: UPDATE_TOTAL_COUNT, count })
const resetTotalCount = () => ({ type: RESET_TOTAL_COUNT })
const incrementTotalCount = () => ({ type: INCREMENT_TOTAL_COUNT })
const decrementTotalCount = () => ({ type: DECREMENT_TOTAL_COUNT })

export {
  fetchWeeklyUpdates,
  fetchWeeklyUpdatesStart,
  fetchWeeklyUpdatesSuccess,
  fetchWeeklyUpdatesError,
  fetchRemainingWeeklyUpdates,
  fetchRemainingWeeklyUpdatesStart,
  fetchRemainingWeeklyUpdatesSuccess,
  fetchRemainingWeeklyUpdatesError,
  postWeeklyUpdate,
  postWeeklyUpdateStart,
  postWeeklyUpdateSuccess,
  postWeeklyUpdateError,
  deleteWeeklyUpdate,
  deleteWeeklyUpdateStart,
  deleteWeeklyUpdateSuccess,
  deleteWeeklyUpdateError,
  resetNewWeeklyUpdate,
  updateWeekNumber,
  updateYear,
  updateRole,
  updateText,
  updateTotalCount,
  resetTotalCount,
  incrementTotalCount,
  decrementTotalCount
}
